import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '@/store';
import User from '@/models/User';

Vue.use(VueRouter);

const routes = [
    {
        path: '/',
        name: 'home',
        // component: Home
        component: () => import(/* webpackChunkName: "customer" */ '../components/customer/Home.vue'),
        meta: { authorize: true, admin: false, layout: 'main' }
    },
    {
        path: '/screen/:id',
        name: 'screenviewer',
        // component: Home
        component: () => import(/* webpackChunkName: "customer" */ '../components/customer/ScreenViewer.vue'),
        meta: { authorize: true, admin: false, layout: 'main' }
    },
    {
        path: '/login',
        name: 'login',
        component: () => import(/* webpackChunkName: "login" */ '../components/Login.vue'),
        meta: { authorize: false, layout: 'fullpage' }
    },
    {
        path: '/admin',
        name: 'admin',
        component: () => import(/* webpackChunkName: "admin" */ '../components/administration/Admin.vue'),
        meta: { authorize: true, admin: true, layout: 'admin' }
    },
    {
        path: '/admin/companies',
        name: 'admin_companies',
        component: () => import(/* webpackChunkName: "admin" */ '../components/administration/companies/Companies.vue'),
        meta: { authorize: true, admin: true, layout: 'admin' }
    },
    {
        path: '/admin/companydetails/:id',
        name: 'admin_companydetails',
        component: () => import(/* webpackChunkName: "admin" */ '../components/administration/companies/CompanyDetails.vue'),
        meta: { authorize: true, admin: true, layout: 'admin' }
    },
    {
        path: '/admin/users',
        name: 'admin_users',
        component: () => import(/* webpackChunkName: "admin" */ '../components/administration/Users/UsersList.vue'),
        meta: { authorize: true, admin: true, layout: 'admin' }
    },
    {
        path: '/admin/screens/details/:id',
        name: 'admin_screendetails',
        component: () => import(/* webpackChunkName: "admin" */ '../components/administration/screens/ScreenDetails.vue'),
        meta: { authorize: true, admin: true, layout: 'admin' }
    },
    {
        path: '/admin/screens/contents/:id/:screenId',
        name: 'admin_screencontents',
        component: () => import(/* webpackChunkName: "admin" */ '../components/administration/screens/ScreenContents.vue'),
        meta: { authorize: true, admin: true, layout: 'admin' }
    }

    // {
    //     path: '/about',
    //     name: 'about',
    //     // route level code-splitting
    //     // this generates a separate chunk (about.[hash].js) for this route
    //     // which is lazy-loaded when the route is visited.
    //     component: () => import(/* webpackChunkName: "about" */ '../views/About.vue'),
    //     meta: { authorize: false, layout: 'main' }
    // }
];

const router = new VueRouter({
    base: process.env.NODE_ENV === 'production' ? '/' : '/',
    mode: 'history',
    routes
});

router.beforeEach((to: any, from: any, next: any) => {
    // Check if token is set.
    const userInfo = store.state.userInfo as User;
    let isAuthenticated = (Object.keys(userInfo).length > 0 && userInfo.Token !== '');
    let isAdmin = (Object.keys(userInfo).length > 0 && userInfo.IsAdmin === true);
    if (!isAuthenticated) {
        let decodedCookie: string = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(';');

        for (const c of ca) {
            if (c.trim().startsWith('info=')) {
                const contents = c.trim().substring(5);
                const tmpUser = JSON.parse(contents);
                store.commit('setUserInfo', tmpUser);
                isAuthenticated = true;
                isAdmin = (Object.keys(tmpUser).length > 0 && tmpUser.IsAdmin === true);
                break;
            }
        }
    }
    // Check if destination page requires authentication
    if (to.matched.some((record: any) => record.meta.authorize)) {
        const isPriviledged = to.matched.some((record: any) => record.meta.admin) === isAdmin;

        // If The user is not authenticated redirect to login. Else proceed to page
        if (!isAuthenticated || !isPriviledged) {
            next({
                path: '/login'
            });
        } else {
            next();
        }
    } else {
        next();
    }
});
export default router;
